// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a79dd204","213":"fef82a33","239":"f77dd253","453":"7bd79626","455":"d6ccf207"}[chunkId] + ".chunk.js";
};